import { SvgIcon, SxProps } from "@mui/material";
import ReactionHushedSvg from "jsx:../../../Images/Icons/Custom/reactionHushed.svg";

export function ReactionHushedIcon(props: SxProps) {
    return <SvgIcon component={ReactionHushedSvg} inheritViewBox sx={props} />;
}
